export function base64toHEX(base64: string): string {
  const raw = atob(base64);

  let HEX = "";

  for (let i = 0; i < raw.length; i++) {
    const hex = raw.charCodeAt(i).toString(16);
    HEX += hex.length === 2 ? hex : "0" + hex;
    HEX += " ";
  }

  return HEX.toUpperCase();
}

export function padLeft(size: number, num: string): string {
  let s = String(num);
  while (s.length < (size || 2)) {
    s = "0" + s;
  }
  return s;
}

export function secondsToTimeString(seconds: number): string {
  const secs = seconds % 60;
  const wholeMinutes = (seconds - secs) / 60;
  const minutes = wholeMinutes % 60;
  const hours = (wholeMinutes - minutes) / 60;

  return `${padLeft(2, hours.toString())}h ${padLeft(2, minutes.toString())}m ${padLeft(2, secs.toString())}s`;
}



// WEBPACK FOOTER //
// ./src/helpers/convert-utils.ts